import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";

/**
 * Common filter toggle button used across all filter panels.
 *
 * @param {object}   props
 * @param {boolean}  props.isExpanded – Whether the filter panel is expanded
 * @param {function} props.onToggle   – Callback to toggle expanded state
 * @param {string}   [props.label]    – Button label (defaults to "Filter")
 * @param {string}   [props.className] – Extra classes to append
 */
const FilterToggle = ({ isExpanded, onToggle, label = "Filter", className = "" }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`w-full flex items-center gap-2 px-4 py-3 border-b text-sm font-semibold ${className}`.trim()}
      aria-expanded={isExpanded}
      aria-label="Toggle filter panel"
    >
      {isExpanded ? <RiArrowDownSLine /> : <RiArrowRightSLine />}
      {label}
    </button>
  );
};

export default FilterToggle;
